export default __webpack_public_path__ + "static/balance-guy-mobile-136a3e59c6d345217e1c6a4882f2abbd.png";